import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=95c78b22&"
import script from "./ProjectCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports